<template>
  <div class="ma-4">

    <v-snackbar v-model="msg" top> 
      {{ text }} 
      <v-btn color="pink" text  @click="msg = false"> Close</v-btn>
    </v-snackbar>

    <StaffNav />

    <v-row>      
      <v-col cols="12" lg="3" xl="2">
        <StaffSide />
      </v-col>
      <v-col cols="12" lg="9" xl="10">
        <v-card>
          <v-tabs v-model="tab">
            <v-tabs-slider color="yellow"></v-tabs-slider>
            <v-tab v-for="(item, index) in items" :key="index">
              {{ item }}
              <v-chip class="ml-2" color="green" text-color="white" small>
                  {{ index === 0 ? activeCerts : expiredCerts }}
              </v-chip>
            </v-tab>
          </v-tabs>
          
          <v-tabs-items v-model="tab">
            <v-tab-item v-for="(item, i) in items" :key="item">
              <v-data-table
                :options.sync="options"
                :headers="headers"
                :items="i === 0 ? staffCerts : expired"
                sort-by="DateIssued"
                sort-desc
                class="elevation-1"
                :loading="isLoading"
                loading-text="Loading Certifications"
                :search="search"
                height="550"
              >
              

          <template v-slot:item="{ item }">
            <tr :class="getRowClass(item)">
              <td>{{ item.CertificationType }}</td>
              <td>{{ item.Certification }}</td>
              <td>{{ item.Focus }}</td>
              <td>{{ item.Details }}</td>
              <td>{{ item.DateIssued }}</td>
              <td>{{ item.Expiration }}</td>
              <td>{{ item.Status }}</td>
              <td>
                <v-icon small class="mr-2" @click="downloadDocument(item)">
                  mdi-download
                </v-icon>
                <v-icon small class="mr-2" @click="viewStaffCert(item._id)">
                  mdi-eye
                </v-icon>
                <v-icon small @click="deleteStaffCert(item)">
                  mdi-delete
              </v-icon>
              </td>
            </tr>
          </template>
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Certifications</v-toolbar-title>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    clearable
                    flat
                    solo-inverted
                    hide-details
                    prepend-inner-icon="search"
                    label="search"
                    class="desktop"
                  ></v-text-field>
                  <v-spacer></v-spacer>
                  <v-btn v-if="!isAuditorRole" color="#2b3990" class="mb-2 white--text" v-on="on" @click="showAdd()">
                    <v-icon left>add</v-icon>
                    Add Certification
                  </v-btn>
                  </v-toolbar>
                </template>
              </v-data-table>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>

    </v-row>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import StaffNav from '@/components/StaffNav'
import StaffSide from '@/components/StaffSide'

const url = require("../../client_config/config").url;

  export default {
    components: {
      StaffNav,
      StaffSide
    },

    data: function() {
      return {
      headers: [
        {
          text: 'Certification Type',
          align: 'start',
          sortable: true,
          value: 'CertificationType',
        },
        { text: "Certification", value: "Certification" },
        { text: "Focus", value: "Focus" },
        { text: "Details", value: "Details" },
        { text: "Date Issued", value: "DateIssued" },
        { text: "Date Expires", value: "Expiration" },
        { text: "Status", value: "Status" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      tab: null,
      items: ["Active Certifications", "Archived Certifications"],
      msg: false,
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      search: "",
      text:"",
      certs: "",
      staffCerts: [],
      expiring: [],
      expired: [],
      isLoading: true,
      tempData: [],
      certifications: [],
      employeeID: this.$route.params.employeeID,
      uploadFile: "",
      page: 1,
      pageCount: 1,
      itemCount: 0,
      options: {},
      staffCertID: this.$route.params.id,
      on: false,
    }
  },
  

  computed: {
    activeCerts() {
        return this.staffCerts.length;
    },
    expiredCerts() {
        return this.expired.length;
    },
    isAuditorRole() {
        return localStorage.getItem("userRole") === 'Auditor'
    }
  },

  watch: {
    options: {
      handler() {
        this.getStaffCerts();
      },
      deep: true
    }
  },

  methods: {
    getStaffCerts: function() {
      this.isLoading = true;
      axios.get(`${url}/staffCertifications/staff/${this.employeeID}`)
        .then(response => {
          this.tempData = response.data.staffCerts;

          this.expired = [];
          this.staffCerts = [];
          for(var i = 0; i < this.tempData.length; i++){
            if(this.tempData[i].Status == 'Archived'){
              this.expired.push(this.tempData[i])
            } else {
              this.staffCerts.push(this.tempData[i])
            }
          }
        })
        .catch(error => console.log({error}))
        .finally(() => this.isLoading = false);
    },
    
    getRowClass(item) {
      const currentDate = moment(); // Get the current date using Moment.js
      const expirationDate = moment(item.Expiration, 'YYYY-MM-DD'); // Parse expiration date using Moment.js

      // Check if expirationDate is valid and whether it's in the past
      if (expirationDate.isValid() && item.Status === 'Current' && expirationDate.isBefore(currentDate, 'day')) {
        return 'pink';
      }

      return '';
    },
    
    downloadDocument(item){
      if(item.documents === undefined){
              this.msg=true;
              this.text ="No document found";
      }else{
        for(let i = 0; i < item.documents.length ; i++){
          let docURL = item.documents[i].AWSLink;
          var FileSaver = require('file-saver');
          FileSaver.saveAs(docURL, item.documents[i].Name);
        }
      }
    },

    deleteStaffCert(item) {
      const id = item._id;
      confirm("Are you sure you want to delete this certification?") &&
      this.staffCertDelete(id);
    },

    staffCertDelete(id) {
      axios.delete(`${url}/staffCertifications/${id}`)
      .then((response) => {
        this.staffCerts =  [...this.staffCerts.filter((certificate) => certificate._id != id)];
        this.expired =  [...this.expired.filter((certificate) => certificate._id != id)];
        this.getStaffCerts();
        if (response.status == 400) {
          response.json().then(function(data) {
            return data.msg;
          });
        }
        this.msg=true;
        this.text="The certification has been deleted successfully.";
      });
    },
    
    showAdd() {
      this.$router.push({
        path: `/Certifications/${this.employeeID}/add`,
      });
    },

    viewStaffCert(id) {
      this.$router.push({
        path: `/Certifications/${this.employeeID}/edit/${id}`,
      });
    },
  }
}
</script>